import { render, staticRenderFns } from "./Investor.vue?vue&type=template&id=3dd2cbbf&scoped=true"
import script from "./Investor.vue?vue&type=script&lang=ts"
export * from "./Investor.vue?vue&type=script&lang=ts"
import style0 from "./Investor.vue?vue&type=style&index=0&id=3dd2cbbf&prod&lang=css"
import style1 from "./Investor.vue?vue&type=style&index=1&id=3dd2cbbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2cbbf",
  null
  
)

export default component.exports